
if (!customElements.get("product-form")) {
// ---- Gratis-Einlegesohle beim Hausschuh automatisch hinzufügen ----
async function addFreeInsoleIfNeeded(variant, quantity) {
  const cfg = window.FREE_INSOLE_CONFIG;
  if (!cfg) return null;

  try {
    if (!variant) return null;

    // nur für den Hausschuh
    if (variant.product_id !== cfg.SLIPPER_PRODUCT_ID) return null;

    const options = variant.options || [];
    const size = options[cfg.SIZE_OPTION_INDEX] || null; // z.B. "35-36"
    if (!size) return null;

    const insoleVariantId = cfg.variantsBySize[size];
    if (!insoleVariantId) {
      console.warn("Keine Einlegesohle für Größe", size, "konfiguriert");
      return null;
    }

    const payload = {
      id: insoleVariantId,
      quantity: quantity || 1,
      properties: {
        [cfg.GIFT_PROPERTY_KEY]: "1", // Markierung als Gratis-Produkt
      },
    };

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      console.warn("Gratis-Einlegesohle konnte nicht hinzugefügt werden");
      return null;
    }

    // WICHTIG: aktualisierten Warenkorb zurückgeben
    const data = await res.json();
    return data;
  } catch (e) {
    console.warn("Fehler beim Hinzufügen der Gratis-Einlegesohle", e);
    return null;
  }
}
// ---- Ende Gratis-Einlegesohle-Helfer ----
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        this.upsellVariantId = this.dataset.upsellVariantId;

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        // Cart-Abschnitte für Drawer/Notification
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // Checkout-Skip-Flag
        this.skipCart = false;
        const variantInput = this.form.querySelector("[name=id]");
        console.log("Variant input:", variantInput);
        console.log("Variant input dataset:", variantInput?.dataset);
        console.log("Skip cart dataset:", variantInput?.dataset?.skipCart);
        if (variantInput?.dataset?.skipCart === "true") {
          this.skipCart = true;
          console.log("Skip cart enabled");
        }

        const quantity = Number(formData.get("quantity")) || 1;

        // Alles weitere als async-Flow (Arrow-Funktion = this bleibt erhalten)
        (async () => {
          try {
            // 1) Optional Upsell-Produkt hinzufügen, wenn Warenkorb leer
            if (this.upsellVariantId) {
              try {
                const cartRes = await fetch(`${routes.cart_url}.js`);
                const cartState = await cartRes.json();
                if (cartState.item_count === 0) {
                  await fetch(
                    `${routes.cart_add_url}`,
                    this.getUpsellProductConfig()
                  );
                }
              } catch (e) {
                console.warn("Upsell-Check fehlgeschlagen", e);
              }
            }

            // 2) Hauptprodukt (Hausschuh) in den Warenkorb legen
            const addRes = await fetch(`${routes.cart_add_url}`, config);
            const response = await addRes.json();

            // Fehler vom /cart/add.js
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (this.skipCart) {
              console.log("Redirecting to checkout");
              window.location = "/checkout";
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // 3) GRATIS-EINLEGESOHLE in gleicher Größe hinzufügen
            const giftCart = await addFreeInsoleIfNeeded(
              this.currentVariant,
              quantity
            );

            // 4) Cart-UI aktualisieren:
            //    Wir feuern nur das Event – das Theme lädt sich danach selbst
            //    die aktuellen Cart-Sections (inkl. Gratis-Sohle) nach.
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            }
            this.error = false;

            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              // Wenn du Quick-Add benutzt: nach Schließen des Modals
              // einfach den Drawer normal öffnen
              document.body.addEventListener(
                "modalClosed",
                () => {
                  if (this.cart && typeof this.cart.open === "function") {
                    this.cart.open();
                  }
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else if (this.cart && typeof this.cart.open === "function") {
              // Normaler Produkt-Page-Fall:
              // Drawer öffnen, Inhalt wurde durch cartUpdate schon neu geladen
              this.cart.open();
            }
          } catch (e) {
            console.error(e);
          } finally {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error)
              this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          }
        })();
      }
      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append("id", this.upsellVariantId);
        upsellFormData.append("quantity", 1);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = upsellFormData;

        return config;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
